import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lkd-card-ico',
  templateUrl: './card-ico.component.html',
  styles: []
})
export class CardIcoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
